import Badge from '@mui/material/Badge';
import IconButton from 'Components/Buttons/IconButton/index.js';
import React from 'react';
import icons from 'utils/ui/icons.js';
import { openMeterPhoto } from '../renderUtils';
import { photoBadgeSx, StyledCommentsField } from '../reportStyles';

const TechnicalReport = props => {
    const { image, technicianComments, validated } = props;
    const { onDiscardImage, onTechnicianCommentsChange } = props;

    return (
        <>
            {image && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 16, marginBottom: 8 }}>
                    <Badge badgeContent={1} sx={photoBadgeSx}>
                        <IconButton icon={['fas', 'image']} onClick={() => openMeterPhoto(image)} style={{ padding: 0 }} tooltip="Meter Photo"/>
                    </Badge>
                    {/* A data-URL image is a capture that has not been submitted yet, so it can
                     still be discarded locally; one already on the server would need the API
                     to remove it. */}
                    {typeof image === 'string' && (
                        <IconButton icon={icons.trash} onClick={onDiscardImage} style={{ padding: 0 }} tooltip="Discard photo"/>
                    )}
                </div>
            )}
            {validated ? (
                technicianComments && (
                    <div style={{ fontSize: '0.65rem', whiteSpace: 'pre-wrap', marginTop: 12 }}>
                        {technicianComments}
                    </div>
                )
            ) : (
                <StyledCommentsField
                    margin="none"
                    minRows={3}
                    multiline
                    onChange={e => onTechnicianCommentsChange(e.target.value)}
                    placeholder=""
                    style={{ marginTop: 12 }}
                    value={technicianComments}
                    variant="filled"
                />
            )}
        </>
    );
};

export default TechnicalReport;
